import { uniqueId } from 'lodash';
import checkInIcon from '../../images/links/ta/icon_checkin.svg';
import checkinFailureIcon from '../../images/links/ta/icon_checkin_failure.svg';
import leaveFormIcon from '../../images/links/ta/icon_leave_eform.svg';
import workTimeTableIcon from '../../images/links/ta/icon_work_timetable.svg';
import overtimeFormIcon from '../../images/links/ta/icon_overtime_eform.svg';
import workTimeTableApproveIcon from '../../images/links/ta/icon_work_timetable_approval.svg';
const module = 'TA';

export default [
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_LeaveForm',
    icon: leaveFormIcon,
    url: '/ta/personal/AskForLeavePage',
    messageApi: null,
    sort: 1,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_OvertimeForm',
    icon: overtimeFormIcon,
    url: '/ta/personal/OvertimeRequestFormPage',
    messageApi: null,
    sort: 2,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_CheckIn',
    icon: checkInIcon,
    url: '/ta?id=webpunch',
    messageApi: null,
    sort: 3,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_ForgetCheckInForm',
    icon: checkinFailureIcon,
    url: '/ta?id=webforgetpunch',
    messageApi: null,
    sort: 4,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_PersonalWorkTimetable',
    icon: workTimeTableIcon,
    url: '/ta/personal/shiftschedule',
    messageApi: null,
    sort: 5,
    onlySupervisor: false,
  },
  {
    id: uniqueId(),
    module,
    i18nKey: 'SH_WorkTimetableForApproval',
    icon: workTimeTableApproveIcon,
    url: '/ta/supervisor/shiftscheduleapprovelist',
    messageApi: null,
    sort: 6,
    onlySupervisor: true,
  },
];



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/config/links/ta.js
 **/